<template>
  <div class="main-container">
    <div class="search-box btn3" :class="{ 'close': !searchMore }">
      <div class="input-item select-two">
        <Select v-model="searchParams.dateType" :transfer="true">
          <Option value="1">承保日期</Option>
          <Option value="2">支付日期</Option>
          <Option value="3">起保日期</Option>
        </Select>
        <DatePicker
          v-model="searchParams.date"
          type="daterange"
          split-panels
          separator=" 至 "
          :transfer="true"
          placement="bottom"
          format="yyyy-MM-dd"
          placeholder="选择日期"
        ></DatePicker>
      </div>
      <div class="input-item">
        <span class="label">保险公司</span>
        <Select v-model="searchParams.companyCode" :transfer="true" filterable clearable>
          <Option v-for="(item, i) in companyList" :key="i" :value="item.code">{{ item.name }}</Option>
        </Select>
      </div>
      <div class="input-item select-two">
        <Select v-model="searchParams.orderType" :transfer="true">
          <Option value="1">保单号</Option>
          <Option value="2">订单号</Option>
        </Select>
        <Input v-model="searchParams.no" placeholder="请输入" clearable />
      </div>
      <div class="input-item">
        <span class="label">状态</span>
        <Select v-model="searchParams.statusList" multiple :max-tag-count="2" :transfer="true" clearable>
          <Option value="1">保障中</Option>
          <Option value="-1">退保</Option>
          <Option value="0">终止</Option>
        </Select>
      </div>
      <div class="input-item">
        <span class="label">产品名称</span>
        <Input v-model="searchParams.productName" placeholder="请输入" clearable />
      </div>
      <div class="input-item">
        <span class="label">投保人名称</span>
        <Input v-model="searchParams.holderName" placeholder="请输入" clearable />
      </div>
      <div class="input-item">
        <span class="label">投保人证件号</span>
        <Input v-model="searchParams.cardNo" placeholder="请输入" clearable />
      </div>
      <div class="input-item" v-if="userInfo.userType != 4">
        <span class="label">所属机构</span>
        <selectTree type="4" v-model="searchParams.orgIds" @change="getGroupList" ref="selectTree" :multiple="true"></selectTree>
      </div>
      <div class="input-item" v-if="userInfo.userType != 4">
        <span class="label">所属团队</span>
        <Select v-model="searchParams.groupIds" clearable multiple filterable>
          <Option v-for="(bean, i) in groupList" :key="i" :value="bean.groupId">
            {{ bean.groupCode ? bean.groupName + '-' + bean.groupCode : bean.groupName }}
          </Option>
        </Select>
      </div>
      <div class="input-item" v-if="userInfo.userType != 4">
        <span class="label">业务员</span>
        <Select clearable v-model="searchParams.salesmanId" style="width: 256px" filterable :transfer="true">
          <Option :value="item.id" v-for="(item, index) in salesmanList" :key="index" :label="item.staffNo + (item.staffNo ? '/' : '') + item.name"> </Option>
        </Select>
      </div>
      <div v-if="$units.isOkTX() || $units.isOkBao() || $units.isRYBB()" class="input-item">
        <span class="label">推广执行人</span>
        <lzDicSelect v-model="searchParams.executer" dicType="USER_EXECUTER" :transfer="true" clearable> </lzDicSelect>
      </div>
      <div v-if="$units.isOkTX() || $units.isOkBao() || $units.isRYBB()" class="input-item">
        <span class="label">推广渠道</span>
        <lzDicSelect v-model="searchParams.channel" dicType="USER_CHANNEL" :transfer="true" clearable> </lzDicSelect>
      </div>
      <div v-if="$units.isOkBao() || $units.isRYBB()" class="input-item">
        <span class="label">团险销售支持</span>
        <Select v-model="searchParams.groupSalesSupportId" clearable filterable>
          <Option v-for="(item, i) in groupSalesSupportList" :key="i" :value="item.id" :label="item.name"></Option>
        </Select>
      </div>
      <div class="input-item" v-if="$units.showSupplier() && $units.pointAction('order_50_21')">
        <span class="label">供应商类型</span>
        <RadioGroup v-model="searchParams.supplierType" @on-change="changeOriginSupplierType">
          <Radio label="">全部</Radio>
          <Radio label="1">保司</Radio>
          <Radio label="2">通道</Radio>
        </RadioGroup>
      </div>
      <div v-if="searchParams.supplierType && $units.showSupplier() && $units.pointAction('order_50_21')" class="input-item">
        <span class="label">供应商</span>
        <Select v-model="searchParams.supplierIds" multiple :max-tag-count="4" clearable filterable transfer>
          <Option v-for="item in supplierList" :key="item.value" :value="item.value">{{ item.label }}</Option>
        </Select>
      </div>
      <div class="input-item">
        <div class="policy-search-box">
          <Poptip placement="bottom" width="600">
            <Tooltip
              placement="top"
              content="输入多个保单号批量搜索"
              transfer
              :disabled="searchParams.policyNoList && searchParams.policyNoList.split('\n').filter(item => item).length ? true : false"
            >
              <Button type="primary" icon="ios-search">批量查询</Button>
            </Tooltip>
            <div class="api policy-num" slot="content">
              <span class="title">请输入保单号，多个保单号换行输入</span>
              <Input v-model="searchParams.policyNoList" :rows="7" type="textarea" />
              <div class="text">
                <Poptip placement="bottom" trigger="hover" style="width: 60px" width="250">
                  <div class="example-text">输入示例</div>
                  <div class="api policy-num" slot="content">
                    <div class="tip">每一行一个保单号</div>
                    <Input v-model="policyExample" :rows="5" type="textarea" disabled />
                  </div>
                </Poptip>
                <div
                  class="clearable"
                  @click="searchParams.policyNoList = ''"
                  v-if="searchParams.policyNoList && searchParams.policyNoList.split('\n').filter(item => item).length"
                >
                  清空
                </div>
              </div>
            </div>
          </Poptip>
          <div class="tip-nums" v-if="searchParams.policyNoList">
            {{ searchParams.policyNoList && searchParams.policyNoList.split('\n').filter(item => item).length }}
          </div>
        </div>
      </div>
      <div class="btn-item">
        <Button type="primary" @click="searchAjax()">搜索</Button>
        <Button type="primary" ghost @click="resetSearch">重置</Button>
        <Button type="primary" ghost v-if="searchMore" @click="searchMore = false"
          >收起
          <Icon type="ios-arrow-up" />
        </Button>
        <Button type="primary" ghost v-else @click="searchMore = true"
          >展开
          <Icon type="ios-arrow-down" />
        </Button>
      </div>
    </div>
    <div class="tools-box">
      <div class="left total-box">
        <span>
          共<b>{{ totalInfo.counts }}</b
          >单
        </span>
        <span>
          已支付保费：<b> {{ totalInfo.issueFee | number_format(2) }}</b
          >元
        </span>
        <span>
          退保保费：<b>{{ totalInfo.refundFee | number_format(2) }}</b
          >元
        </span>
      </div>
      <div class="right">
        <Button type="warning" @click="addPolicyForm()" v-show="$units.pointAction('order_50_11')">新增</Button>
        <Button
          type="primary"
          ghost
          v-show="$units.pointAction('order_50_13')"
          @click="
            $refs.importModal.open({
              template: '/buz/importTask/exportTemplate',
              upload: '/buz/grouppolicy/enter/policy/import'
            })
          "
          >导入</Button
        >
        <Button type="primary" ghost @click="exportToExcel" v-show="$units.pointAction('order_50_3')">导出</Button>
        <Dropdown
          :transfer="true"
          @on-click="dropdownClick1($event)"
          style="margin-left: 10px"
          v-if="$units.pointAction('order_50_19') || $units.pointAction('order_50_18')"
        >
          <Button type="primary" ghost>批量更新 <Icon type="ios-arrow-down"></Icon></Button>
          <template #list>
            <DropdownMenu>
              <DropdownItem name="changeBaseMassege" v-if="$units.pointAction('order_50_19')">批量更新基本信息</DropdownItem>
              <DropdownItem name="changeStatus" v-if="$units.pointAction('order_50_18')">批量更新保单状态</DropdownItem>
            </DropdownMenu>
          </template>
        </Dropdown>
      </div>
    </div>
    <div class="table-box">
      <loading :isShow="listLoading" />
      <Table :columns="columns" :data="tableData">
        <template slot-scope="{ row }" slot="sellTypeSlot">
          <div class="sellTypeColumn" v-if="row.sellTypes">
            <Tag color="blue" v-if="row.sellTypes.includes('1')">网销</Tag>
            <Tag color="blue" v-if="row.sellTypes.includes('2')">电销</Tag>
            <Tag color="blue" v-if="row.sellTypes.includes('3')">经代</Tag>
          </div>
          <div v-else>-</div>
        </template>
        <template slot-scope="{ row }" slot="executer">
          <lzDicTxt v-if="row.executer" dicType="USER_EXECUTER" :dicCode="row.executer"></lzDicTxt>
          <span v-else>-</span>
        </template>
        <template slot-scope="{ row }" slot="channel">
          <lzDicTxt v-if="row.channel" dicType="USER_CHANNEL" :dicCode="row.channel"></lzDicTxt>
          <span v-else>-</span>
        </template>
        <template slot-scope="{ row }" slot="commission">
          <span v-if="$units.pointAction('order_50_14')">{{ row.commission | number_format(2) }}</span>
          <span v-else>****</span>
        </template>
        <template slot-scope="{ row }" slot="action">
          <span class="table-btn" @click="detail(row)">详情</span>
          <span class="table-btn" @click="editGroupList(row)" v-if="!(row.type == 1 || row.dockChannel == 3) && $units.pointAction('order_50_11')">编辑</span>
          <Dropdown :transfer="true" trigger="hover" @on-click="dropdownClick($event, row)">
            <div class="more-btn">
              更多
              <Icon type="ios-arrow-down"></Icon>
            </div>
            <DropdownMenu slot="list">
              <DropdownItem name="copy" v-if="!(row.type == 1 || row.dockChannel == 3) && $units.pointAction('order_50_16')">复制</DropdownItem>
              <DropdownItem name="change" v-if="$units.pointAction('order_50_15')">变更归属</DropdownItem>
              <DropdownItem name="policy" v-if="$units.pointAction('order_50_2') && row.policyUrl && (row.type == 1 || row.dockChannel == 3)">
                下载保单
              </DropdownItem>
              <DropdownItem name="underlinePolicy" v-if="$units.pointAction('order_50_2') && row.contract && row.contract.length > 0 && row.type == 2">
                电子保单</DropdownItem
              >
              <DropdownItem name="delete" v-if="!(row.type == 1 || row.dockChannel == 3) && $units.pointAction('order_50_12')">删除</DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </template>
      </Table>
    </div>
    <Page
      :total="total"
      :current="pageNum"
      :page-size="pageSize"
      show-total
      @on-change="getList"
      style="text-align: center"
      show-sizer
      :page-size-opts="[10, 20, 30, 50, 100]"
      @on-page-size-change="pageSizeChange"
    />

    <!-- 导入保单  -->
    <import-modal ref="importModal" code="groupPolicy" @success="getList()"></import-modal>
    <!-- 划单 -->
    <order-transfer ref="orderTransfer" @success="getList()"></order-transfer>
    <Modal v-model="showPolicy" title="电子保单" width="800" :loading="$root.$children[0].modalLoading" footer-hide>
      <resource ref="resourceRef" :urlList="urlList" width="100px" height="100px"></resource>
    </Modal>
    <updatePolicyModal ref="updatePolicyModal" :searchParams="searchParams" @searchAjax="searchAjax" @setListParams="setListParams"></updatePolicyModal>
    <updateBaseMassegeModal
      ref="updateBaseMassegeModal"
      :searchParams="searchParams"
      @searchAjax="searchAjax"
      @setListParams="setListParams"
    ></updateBaseMassegeModal>

    <!-- 多个保单号查询搜索结果 -->
    <noPolicyNumberModal ref="noPolicyNumberRef"></noPolicyNumberModal>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import noPolicyNumberModal from './components/noPolicyNumberModal';
import { pageTool, common } from '@/api/mixins';
import { mapState } from 'vuex';
import { config } from './index.config.js';
import selectTree from '@/components/system/selectTree3';
import orderTransfer from './components/orderTransfer';
import importModal from './components/importModal';
import resource from '@/components/commons/resource';
import lzDicTxt from '@/components/commons/lzDicTxt';
import lzDicSelect from '@/components/commons/lzDicSelect';
import updatePolicyModal from './components/updatePolicyModal.vue';
import updateBaseMassegeModal from './components/updateBaseMassegeModal.vue';
export default {
  mixins: [pageTool, config, common],
  components: {
    noPolicyNumberModal,
    orderTransfer,
    selectTree,
    importModal,
    resource,
    updatePolicyModal,
    updateBaseMassegeModal,
    lzDicSelect,
    lzDicTxt
  },
  data() {
    return {
      supplierList: [], //供应商列表
      urlList: [], //资源列表
      showPolicy: false,
      listLoading: false,
      searchParams: {
        dateType: '1',
        orderType: '1',
        groupSalesSupportId: ''
      },
      companyList: [],
      groupList: [],
      salesmanList: [], //所属业务员
      totalInfo: {},
      draftCount: 1,
      policyExample: '0012346464351321\nFFVFGTY42311131F\nWWDFERRTW2243543\nOPKUHNGY4323234F\n...',
      groupSalesSupportList: [] //团险销售支持
    };
  },
  computed: {
    ...mapState(['userInfo'])
  },
  created() {
    if (!this.$units.superviseShowVal()) {
      this.searchParams.supplierType = '1';
    }
    this.tableData = [];
    this.getColumns();
    this.getCompanyList();
    this.getOrganizationUser(null);
    this.initListParams('/buz/grouppolicy/read/list');
    // 首页没带参数跳转时初始化
    if (!this.$route.query.organizationId) {
      this.searchParams.applyOrgId = this.$route.query.organizationId;
      this.searchParams.organizationId = this.$route.query.organizationId;
      this.$nextTick(() => {
        this.$refs.selectTree && this.$refs.selectTree.openChange(true);
      });
      this.getGroupList();
    }
  },
  activated() {
    // 首页带参数跳转过来
    if (this.$route.query.organizationId) {
      this.searchParams.applyOrgId = this.$route.query.organizationId;
      this.searchParams.organizationId = this.$route.query.organizationId;
      this.$nextTick(() => {
        this.$refs.selectTree && this.$refs.selectTree.openChange(true);
      });
      this.getGroupList();
    }
    if(sessionStorage.queryPolicyNo) {
      this.searchParams.policyNo = sessionStorage.queryPolicyNo;
      sessionStorage.removeItem('queryPolicyNo');
    }
    this.getList();
    if (this.$units.isOkBao() || this.$units.isRYBB()) {
      this.getOkBaoSalesSupport();
    }
  },
  methods: {
    // 供应商类型切换
    changeOriginSupplierType(value) {
      this.searchParams.supplierIds = [];
      if (!value) {
        this.supplierList = [];
        return;
      }
      this.$http({
        url: value == 1 ? '/buz/insuranceCompany/read/list' : '/buz/insuranceChannel/read/list',
        type: 'POST',
        data: {}
      }).then(res => {
        if (value) {
          this.supplierList = res.data.map(i => {
            return {
              value: i.id,
              label: i.name
            };
          });
        } else {
          this.supplierList = [];
        }
      });
    },
    // 获取个险、团险销售支持
    getOkBaoSalesSupport() {
      // this.$http({
      //   url: '/buz/userBase/okbao/getSalesSupport',
      //   type: 'GET',
      //   data: {
      //     type: 1
      //   }
      // }).then(res => {
      //   if(res.data) {
      //     this.salesSupportList = res.data;
      //   }
      // });
      this.$http({
        url: '/buz/userBase/okbao/getSalesSupport',
        type: 'GET',
        data: {
          type: 2 // 团险
        }
      }).then(res => {
        if (res.data) {
          this.groupSalesSupportList = res.data;
        }
      });
    },
    // 更多操作
    dropdownClick1(name) {
      if (name == 'changeStatus') {
        this.$refs.updatePolicyModal.open();
      } else if (name == 'changeBaseMassege') {
        this.$refs.updateBaseMassegeModal.open();
      }
    },
    dropdownClick(e, item) {
      if (e == 'delete') {
        this.delGroupList(item);
      } else if (e == 'change') {
        this.$refs.orderTransfer.open(item, '变更归属');
      } else if (e == 'policy') {
        window.open(item.policyUrl, '_blank');
      } else if (e == 'underlinePolicy') {
        this.goUnderlinePolicy(item);
      } else if (e == 'copy') {
        this.editGroupList(item, 'copy');
      }
    },
    // 获取文件类型
    checkType(path) {
      return path && path.split('.').pop().toLowerCase();
    },
    goUnderlinePolicy(item) {
      if (item.contract.length > 1) {
        this.urlList = item.contract.map(i => {
          return { path: i.url, fileName: i.url.split('/')[i.url.split('/').length - 1] };
        });
        this.showPolicy = true;
      } else {
        let path = item.contract[0].url;
        if (['png', 'jpg', 'jpeg'].includes(this.checkType(path))) {
          this.urlList = item.contract.map(i => {
            return { path: i.url, fileName: i.url.split('/')[i.url.split('/').length - 1] };
          });
          this.showPolicy = true;
        } else if (this.checkType(path) == 'pdf') {
          window.open(path, '_blank');
        } else {
          location.href = path;
        }
      }
    },
    // 获取团队列表
    getGroupList(data) {
      this.$http({
        url: '/buz/organizationGroup/listSubGroup',
        type: 'post',
        data: {
          organizationId: data
        }
      }).then(res => {
        this.groupList = res.data;
        this.searchParams.groupIds = [];
      });
    },
    setReqParams(params) {
      params.apiPermissionCode = 'order_50_0';
    },
    listCallback(res) {
      res.data.forEach(item => {
        if (item.contract) {
          item.contract = JSON.parse(item.contract);
        }
      });
      this.getTotalInfo();
    },
    getTotalInfo() {
      let params = JSON.parse(JSON.stringify(this.searchParams));
      this.setListParams(params);
      params.pageNum = this.pageNum;
      params.pageSize = this.pageSize;
      this.$http({
        url: `/buz/grouppolicy/count`,
        type: 'POST',
        data: params
      }).then(res => {
        this.totalInfo = res.data;
        if (res.data.policyNoList.length) {
          this.$refs.noPolicyNumberRef.open(res.data.policyNoList);
        }
      });
    },
    // 导出
    exportToExcel() {
      this.listLoading = true;
      let params = JSON.parse(JSON.stringify(this.searchParams));
      this.setListParams(params);
      params.pageNum = this.pageNum;
      params.pageSize = this.pageSize;
      this.$http({
        url: '/buz/grouppolicy/export',
        type: 'POST',
        responseType: 'blob',
        data: params,
        apiPermissionCode: 'order_50_3'
      })
        .then(res => {
          this.listLoading = false;
          this.$units.daochu(res);
        })
        .catch(e => {
          this.listLoading = false;
        });
    },
    detail(row = {}) {
      this.$router.push({
        path: '/orderManage/group/policyDetail',
        query: {
          id: row.id || '',
          policyNo: row.policyNo,
          orderNo: row.orderNo,
        }
      });
    },
    // 删除
    delGroupList(row) {
      this.$Modal.confirm({
        title: '确定删除吗？',
        onOk: () => {
          this.$http({
            url: `/buz/grouppolicy/enter/delete`,
            type: 'GET',
            data: {
              policyNo: row.policyNo
            }
          }).then(res => {
            this.$notice.success('删除成功');
            this.getList();
          });
        },
        onCancel: () => {}
      });
    },
    // 新增
    addPolicyForm() {
      this.openPageTabTags('/orderManage/group/addGroupPolicy', { editFlag: 'add' });
    },
    // 编辑
    editGroupList(row, flag = 'edit') {
      this.openPageTabTags('/orderManage/group/editGroupPolicy', {
        policyNo: row.policyNo,
        editFlag: flag
      });
    },
    // 通过机构获取业务员
    getOrganizationUser(id) {
      this.$http({
        url: `/buz/userBase/getByOrgIds`,
        type: 'POST',
        data: {
          orgaList: id ? [id] : []
        }
      }).then(res => {
        this.salesmanList = res.data;
      });
    },

    // 通过机构获取业务员
    getGroupUser(id) {
      this.$http({
        url: `/buz/userBase/getByGroup?groupId=${id}`,
        type: 'GET'
      }).then(res => {
        this.salesmanList = res.data;
      });
    },
    // 组织选择
    selectTreeChange(data) {
      this.searchParams.salesmanId = '';
      if (data.nodeType == 1) {
        //机构
        this.searchParams.organizationId = data.id;
        this.getOrganizationUser(data.id);
        this.searchParams.groupId = '';
      } else if (data.nodeType == 2) {
        //团队
        this.searchParams.organizationId = '';
        this.getGroupUser(data.id);
        this.searchParams.groupId = data.id;
      } else {
        this.searchParams.organizationId = '';
        this.salesmanList = [];
        this.searchParams.groupId = '';
      }
      this.$nextTick(() => {
        this.searchParams.salesmanId = '';
      });
    },
    // 获取保司列表
    getCompanyList() {
      this.$http({
        url: `/buz/insuranceCompany/read/list`,
        type: 'POST',
        data: { companyType: '1' }
      }).then(res => {
        this.companyList = res.data;
      });
    },
    // 转化参数
    setListParams(params) {
      delete params.applyOrgId;
      if (params.date && params.date[0]) {
        let date1 = dayjs(params.date[0]).format('YYYY-MM-DD');
        let date2 = dayjs(params.date[1]).format('YYYY-MM-DD');
        if (params.dateType == 1) {
          //投保日期
          params.issueTimeStart = date1;
          params.issueTimeEnd = date2;
        } else if (params.dateType == 2) {
          //支付日期
          params.payTimeStart = date1;
          params.payTimeEnd = date2;
        } else if (params.dateType == 3) {
          //起保日期
          params.startTimeStart = date1;
          params.startTimeEnd = date2;
        }
      }
      if (params.orderType && params.no) {
        if (params.orderType == 1) {
          params.policyNo = params.no;
        } else if (params.orderType == 2) {
          params.orderNo = params.no;
        }
      }
      // 保单号
      if (params.policyNoList && params.policyNoList.split('\n').filter(item => item).length) {
        params.policyNoList = params.policyNoList.split('\n').filter(item => item);
      }
      delete params.no;
      delete params.orderType;
      delete params.dateType;
      delete params.date;
    }
  }
};
</script>
<style lang="scss" scoped>
.search-box {
  padding-right: 250px;
}

.total-box {
  line-height: 30px;
  height: 30px;
  span {
    padding-right: 10px;
  }

  b {
    color: #236dff;
    font-weight: 400;
  }
}

.more-btn {
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 12px;
  background: #f4f7ff;
  margin-right: 6px;
  white-space: nowrap;
  border: 2px;
  color: #236dff;
  font-size: 13px;
  cursor: pointer;
}
.policy-search-box {
  position: relative;
  .policy-num {
    padding: 5px 0 10px 0px;
    display: flex;
    flex-direction: column;
    .title {
      font-size: 14px;
      margin-bottom: 10px;
    }
    .text {
      margin-top: 10px;
      display: flex;
      align-items: center;
      .example-text {
        color: #236dff;
        cursor: pointer;
      }
      .tip {
        margin: 0px 0 5px 0;
      }
      .clearable {
        color: #236dff;
        cursor: pointer;
        margin-left: 15px;
      }
    }
  }
  .tip-nums {
    background-color: #ff5f00;
    font-size: 12px;
    padding: 0px 5.5px;
    border-radius: 10px;
    position: absolute;
    left: 85px;
    top: -8px;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    letter-spacing: 0.6px;
  }
}
</style>
